// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useRef, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import cn from 'classnames';
import Icon_chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import Icon_check from '../../img/icons/8/check.svg';
import styles from './lang_picker.module.less';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import storage from '/util/storage.js';

const languages = [
    {code: 'de', name: 'Deutsch'},
    {code: 'en', name: 'English'},
    {code: 'es', name: 'Español'},
    {code: 'he', name: 'Hebrew'},
    {code: 'ja', name: '日本語'},
    {code: 'zh', name: '简体中文'},
    {code: 'ru', name: 'Pусский'},
    {code: 'fr', name: 'Français'},
    {code: 'tr', name: 'Türkçe'}
];

const STORAGE_KEY = 'selected_language';

const use_persist_lang_param = ()=>{
  const location = useLocation();
  const history = useHistory();
  useEffect(()=>{
      const stored_lang = storage.get(STORAGE_KEY);
      const params = new URLSearchParams(location.search);
      const url_lang = params.get('lang');
      if (url_lang)
          storage.set(STORAGE_KEY, url_lang);
      else if (stored_lang)
      {
          params.set('lang', stored_lang);
          history.replace({
              ...location,
              search: params.toString()
          });
      }
      const unlisten = history.listen(new_location=>{
          const new_params = new URLSearchParams(new_location.search);
          const current_lang = storage.get(STORAGE_KEY);
          if (current_lang && !new_params.has('lang'))
          {
              new_params.set('lang', current_lang);
              history.replace({
                  ...new_location,
                  search: new_params.toString()
              });
          }
      });
      return ()=>unlisten();
  }, [location.search, history]);
};

interface i_lang_picker_props {
    direction?: 'up' | 'down' | 'right';
    collapsed?: boolean;
    show_on_hover?: boolean;
}

export const Lang_picker = ({direction = 'down', collapsed = false,
    show_on_hover = true}: i_lang_picker_props)=>{
    const {qs, set_qs} = use_qs_with_set();
    const lang_list_ref = useRef(null);
    use_persist_lang_param();
    const [lang_list_visible, set_lang_list_visible] = useState(false);
    const [current_lang, set_current_lang] = useState(()=>{
        return qs.lang || storage.get(STORAGE_KEY) || 'en';
    });
    const handle_lang_select = code=>{
        set_current_lang(code);
        storage.set(STORAGE_KEY, code);
        set_qs({lang: code});
        window.location.reload();
    };
    useEffect(()=>{
        if (show_on_hover || !lang_list_visible)
            return;
        const handle_click_out = (e: MouseEvent)=>{
            const lang_picker_el = lang_list_ref.current.parentElement;
            if (lang_picker_el && !lang_picker_el.contains(e.target as Node))
                set_lang_list_visible(false);
        };
        document.addEventListener('mousedown', handle_click_out);
        return ()=>document.removeEventListener('mousedown', handle_click_out);
    }, [lang_list_visible]);
    return <div className={cn(styles.lang_picker,
      styles[`direction_${direction}`], collapsed && styles.collapsed,
      lang_list_visible && styles.visible)}
      data-elem='lang_picker'
      onMouseEnter={()=>show_on_hover && set_lang_list_visible(true)}
      onMouseLeave={()=>show_on_hover && set_lang_list_visible(false)}
      onClick={()=>{
        if (show_on_hover)
          return;
        set_lang_list_visible(prev=>!prev);
      }}>
      <div className={styles.lang_trigger}>
        {current_lang.toUpperCase()}
        <Icon_chevron_down className={styles.icon}/>
      </div>
      <div className={styles.lang_content} ref={lang_list_ref}>
        <div className={styles.menu_cards}>
          {languages.map(lang=>
            <div
              key={lang.code}
              className={cn(styles.lang_option, {
                [styles.active]: current_lang === lang.code
              })}
              onClick={()=>handle_lang_select(lang.code)}
            >
              <span>{lang.name}</span>
              {current_lang === lang.code && <Icon_check/>}
            </div>
          )}
        </div>
      </div>
    </div>;
};
